import { Exhibitor } from '@planone/bau365/util-fair-data';

export const staticExhibitors: { [id: string]: Exhibitor } = {
  schueco: {
    id: 'schueco',
    fair_id: 'bau23',
    name: 'Schüco',
    display_name: 'Schüco',
    is_highlighted: true,
    description:
      'Schüco ist einer der führenden Anbieter von hochwertigen Fenster-, Tür- und Fassadensystemen aus Aluminium, Kunststoff und Stahl. Produkte von Schüco kommen weltweit millionenfach zum Einsatz und erfüllen höchste Ansprüche an Design, Komfort, Sicherheit und Energieeffizienz.',
    address: {
      street: 'Karolinenstraße',
      house_number: '1-15',
      zip_code: '33609',
      city: 'Bielefeld',
      country: 'Germany',
    },
    contact: {
      phone: '0521 783-0',
      fax: '0521 783-451',
      email: 'info@schueco.com',
    },
    homepage: 'https://www.schueco.com',
    social_media: {
      linked_in: 'https://de.linkedin.com/company/schuco-international-kg',
      xing: 'https://www.xing.com/companies/sch%C3%BCcointernationalkg',
      instagram: 'https://www.instagram.com/schueco/',
      facebook: 'https://www.facebook.com/schueco',
      pinterest: 'https://www.pinterest.de/schuecointernationalkg/',
      youtube: 'https://www.youtube.com/user/schueco',
    },
    contact_persons: [
      {
        id: '1',
        title: '',
        first_name: 'Soeren',
        name: 'Kleine-Beckel',
        job_title: 'Entwicklungsingenieur Türen & Brandschutzsysteme',
        email: 'SKleine-Beckel@schueco.com',
        phone: '0521 783 7685',
        mobile: '',
        avatar: {
          description: 'Person',
          resource:
            'data:image/jpeg;base64,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',
          provider: 'RAW',
        },
      },
    ],
    exhibition_halls: [
      {
        id: 'B3',
        name: 'B3',
        fair_id: 'bau23',
        booths: [
          {
            name: 'Test Booth',
            coordinates: '123',
            area: {
              width: 2,
              depth: 4,
              total: 6,
            },
          },
        ],
      },
    ],
    links: [
      {
        text: 'Plan.One',
        path: 'https://plan.one',
      },
      {
        text: 'Schüco',
        path: 'https://schueco.de',
      },
    ],
    logo: {
      description: 'Logo',
      resource:
        'https://files.api.plan.one/v1/images/a6c71802-dad7-4521-b0c9-7b5fd12ced64?quality=80&background=white&mode=PAD&width=100&height=100',
      provider: 'RAW',
    },
    mood_image: {
      description: 'Mood',
      resource:
        'https://www.schueco.com/resource/responsive-image/1902046/m01-stage/xxl/1/inspiration-meineschiebetuer-spring-img.jpg',
      provider: 'RAW',
    },
    videos: [
      {
        provider: 'YOUTUBE',
        resource: 'Bb7L3wBH3so',
      },
      {
        provider: 'YOUTUBE',
        resource: 'dYrMRd4DSkU',
      },
      {
        provider: 'YOUTUBE',
        resource: 'zXq_SL-wsrQ',
      },
    ],
    brands: [
      {
        name: 'Plan.One',
        logo: {
          description: 'Plan.One',
          resource:
            'https://lh3.googleusercontent.com/-0grpbwcfteg/AAAAAAAAAAI/AAAAAAAAAAA/58bb9XzwO6w/s44-p-k-no-ns-nd/photo.jpg',
          provider: 'RAW',
        },
      },
      {
        name: 'PlanToBuild',
        logo: {
          description: 'PlanToBuild',
          resource:
            'https://lh6.googleusercontent.com/-JekzGxeFuM4/AAAAAAAAAAI/AAAAAAAAAAA/HNchatNJNxQ/s44-p-k-no-ns-nd/photo.jpg',
          provider: 'RAW',
        },
      },
    ],
    gallery: [
      {
        description: 'Gebäude',
        resource: 'https://www.schueco.com/resource/responsive-image/1974872/m01-stage/xs/1/schueco-imagefilm-data.jpg',
        provider: 'RAW',
      },
      {
        description: 'Gebäude 2',
        resource:
          'https://www.schueco.com/resource/responsive-image/2105200/m01-stage/xs/2/karriere-stage-jobboerse-image.jpg',
        provider: 'RAW',
      },
      {
        description: 'Gebäude 3',
        resource:
          'https://www.schueco.com/resource/responsive-image/24500/m12e-teaser-product-tile/xs/1/schiebesysteme-produktuebersicht.jpg',
        provider: 'RAW',
      },
    ],
    downloads: [
      {
        name: 'Die neue Dimension des Wohnens mit Aluminium-Fenstersystemen',
        file_name: 'Aluminium-Fenstersystemen',
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8044/8703ffacc4ca3d22705b83fa5d46ba73/aluminium_fenster_systeme_p4035.pdf?domain=de',
      },
      {
        name: 'Schüco Living Classic',
        file_name: 'Schüco Living Classic',
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8046/d8c498415a5640cd526db2429652435d/schueco_livlng_classic_P4151.pdf?domain=de',
      },
      {
        name: 'Schüco Livlng Rondo',
        file_name: 'Schüco Livlng Rondo',
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8048/68b37e12213c9d37f8e09565e16a5caf/schueco_livlng_rondo_P4411.pdf?domain=de',
      },
    ],
    topics: [
      {
        id: '2',
        name: 'Fassadengestaltung',
        description: 'Fassadengestaltung',
      },
    ],
    product_groups: [
      {
        id: 'Fenstersystemen',
        external_id: '',
        name: 'Fenstersystem',
        root_path: [],
      },
    ],
    professions: [
      {
        id: 'architect.interior-architect',
        name: 'Architect',
        topics: [
          {
            id: 'sustainable',
            name: 'Sustainable',
            description: 'Sustainable',
          },
        ],
      },
    ],
    is_main: true,
  },
  planone: {
    id: 'planone',
    fair_id: 'bau23',
    name: 'Plan.One',
    display_name: 'Plan.One',
    parent_exhibitor_id: 'schueco',
    is_highlighted: true,
    description:
      'Schüco ist einer der führenden Anbieter von hochwertigen Fenster-, Tür- und Fassadensystemen aus Aluminium, Kunststoff und Stahl. Produkte von Schüco kommen weltweit millionenfach zum Einsatz und erfüllen höchste Ansprüche an Design, Komfort, Sicherheit und Energieeffizienz.',
    address: {
      street: 'Karolinenstraße',
      house_number: '1-15',
      zip_code: '33609',
      city: 'Bielefeld',
      country: 'Germany',
    },
    contact: {
      phone: '0521 783-0',
      fax: '0521 783-451',
      email: 'info@schueco.com',
    },
    homepage: 'https://www.schueco.com',
    social_media: {
      linked_in: 'https://de.linkedin.com/company/schuco-international-kg',
      xing: 'https://www.xing.com/companies/sch%C3%BCcointernationalkg',
      instagram: 'https://www.instagram.com/schueco/',
      facebook: 'https://www.facebook.com/schueco',
      pinterest: 'https://www.pinterest.de/schuecointernationalkg/',
      youtube: 'https://www.youtube.com/user/schueco',
    },
    contact_persons: [
      {
        id: '1',
        title: '',
        first_name: 'Soeren',
        name: 'Kleine-Beckel',
        job_title: 'Entwicklungsingenieur Türen & Brandschutzsysteme',
        email: 'SKleine-Beckel@schueco.com',
        phone: '0521 783 7685',
        mobile: '',
        avatar: {
          description: 'Person',
          resource:
            'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBISEhISEhIPEhIPDw8PDw8PDxEJEhAPJSEnJyUhJCQpLjwzKSw4LSQkNDs0ODE1Nzc3KDE8WUhKPzw+Nz8BDAwMDw8QGBARGDUdGB0xMT8xNjE4PzE0PzE8MTE/PzQ/Pz8xNDExNDQ0NDQ0NDE0NDExMTE0MTExNDExNDE0Mf/AABEIAMgAyAMBIgACEQEDEQH/xAAcAAABBQEBAQAAAAAAAAAAAAAFAAIDBAYBBwj/xAA2EAABAwMCAwcBCAICAwAAAAABAAIDBBEhBTESQVEGEyJhcYGRsQcjMkJSocHwFGLR4TNyc//EABkBAAMBAQEAAAAAAAAAAAAAAAABAgMEBf/EACIRAAICAwEBAAMBAQEAAAAAAAABAhEDITESQQQyUXFCE//aAAwDAQACEQMRAD8A12kQ2aFdrGYUelEcIVis2UTQQ4Z6rZdC5qEuyAfhaBkHG5GKagHMKYxb2U9HltdROB2PwuUVOQRhej6ppTXDAHwhtNpTQdlr5aM9tgHujZU5i5uxK2dTpYAws7X0lifdQ1XTRIBPrHA7q5SaiOapVNObquxlip8pj9fDYU9WLbqy2oHVZNjyBgldGoOaVNDs2kTwVK443WYo9W8/lEm6gCN0BZd4zdWGPQhlWCd0QjlBCVjRHXvwVmK5+SjupS2CyVZUZKI7ZVEUrlRmUj5VXketkRRUlCqPCtyOUJK0EUnKIq8+MFVXxdFDAhukk4JKRn0TpLPCPZW6xmFJQQ2aPZPrWYTkjOGkCaR1nm/ktBCcLPRN8aOU97Ksf6hLpHVyWUFOATdSVjCVFRxlaEXskqS23ysdrcgBwVr62M8PysRrdK7ivnmjymiZTcQTK5VnuCkkhcFUlY5Q4Cjk3ss8QKifESVJRUEsh8Lbgbk4FkVj00NI43WPQAuF1nLzHrOi5S/VFCmpCp5YXAXF0YYzgHhaHbb3CilmxYxnN9s4WfpMP/OaRn6SV5kscrXUTCQPZCaGiYZOIEZIwcG611NSgAYTavaEnK9md1iOzT7rB18tnFeq6pSAixWH1bSmXOMqoR2OU/JmWzJPIK5V0pjPkq/eLbyT7TOSlVi8qSRyu6PTNkd4uqfkHNJWDhJ5H4K4655H4K9OoNBgc0XYDt0V8dmoP0D4CVE+7+HjUjD0PwUl7E/s1D+gfCSXkPb/AIbmj2C7WDCbQHwj0Clqh4UpFRAWzvcI5TPwPQII8eJGqYYCUOBLopd02BgXajqoaeRaEfSxUNFlk9aYLrUTvwVktYkPErijPK9AiSG/JW9K0kSO4n4Yy1/9j0Spad0kjWN3ccno3mVqH0oja1gFg1ox5rDNJxWi/wAbEpSt8B7+7aOFrbAXtZUu6ub2RF8RPVOZBZcDbb2erGMYrRFFS2bvmw+VEaW5ueV+SIgYXHMViBFZpocLtu12DxM8OU+g1gwvbFU4a9wbHNsL9D/yiAJ5c1Xq6VsjS1wBBva4BynGTTIlBNF/VMD5WO1FwJOQjcEzjE6J5JdC0cLjkuj5fG3wsRrErg82PVdUHbPPzqtFXWA22CECfGr0zi7dV3t+i6UYR0UZGqTT6ru3A8rrsowVRcmX09K0XXo7C7gPVGxr8P62/K8SfM9uxITP8yT9R+Vm6Gov4z252vxfrb8hJeJtrX/qPyklSH5l/T6hoB4R6BT1IwoNOPhHoFZqBhRI1jwBlvjHqjEOwQebDr+aJU8osiHAl0kqNiqlM3J9VJUSJtOtER9HzjBWS1YeJa+o/CfdZDVz4laMsoW7IUocZJDya1jfU7o3WtAIuOQHshvY4/dyf+7forGu14iF7cVgLgEBc2X6dWDSRFKMm2BlMaglP2qgkIAD7m1yGE8ObZR9kdwCOa5KdnamqOEj6LhYCuVDmxguebAAk88IU/tJSDAkBd+kX36J0wtIIvYOS7wjfoq8FayT8PED0c0sUj3Y/uykYPqQBICPzNe0+lr/AMLE60wcZ91spMyMHm8n04SshrbD3h9114DzvytMDOjUE0dvhXg3Cimb9F1HImCZm4KHvCMVLcFC5AqNIsoShV3BWZgq7llLpshgXUgkkM+q9MHgHoFanGFX078A9ArU2ymQ48AFWMrtPIQnVgyoWFTj6KY+ol2VqkdhDah+QiFCcXW5mnssznBWO1k+JbCoPhKxurvHF7pojMaPshG5schIIDy1zCccQUmsStZa7C9778LbB2f7zKf2cef8doJ/ICG87XK7NUWJuM5F7cWFx5X/AE7cEaSoxT9Xe2sfTmnh47tHEwhxeLE322xv6LW0FW2SMOA4bgEDBVKWma512gAuweFobcKxHSCNoBJLibuPQcgsLXxHUo/GyHVaoBriWlzQDcAXuFkX6nTRzgSUYLyxrg4Bp4WmwFhcXORsFr6mEuu25Adz3Q9mgx8TXyBj3MtwPcAHsA2shVdsbjrQqaSN4vGLcJLSM3Yb7IjHe13b2N+abFRMY4ua2xdYvIueI+asSEBJgC4hxS36B59rLNazF94VrAwtDnMbxPJsL+EBpOUL1OIFxwunAzz/AMuLSTMt3OFVqY0Zqo+FCKly7EeensE1IwULkCJVLt0PcmdCKE7VUer87VRl3WbNojGpJNSWYz6p0l92N9Ar0pwhujMIjbfoERk29kS6EeID1e6pAq9VNuUoaQHfP7KIOmOavgIqX5HsilC7ATKugbyFlaoIQ0Lb0jKMWnsfMcLH6rE4uwCc8gSt73Y8lA+mHQJKVDlj9A3s7CWtY4/nh4S044eEm31V2tiF0+OKz2H9Ic32UVc44zYHn5Lln9OzH838KTHND9wALkvI4rKQyRyNEjJGvY4Gz2kPBKhjjuC5tnAEg2INiqsnELi1wTdzcWv1Wa0jfrtElNVRyE929kga7heGPD+F3srjGg/8FCADGS4RgON/EGhv0T2aieIYIPni4S4UFi0BD6p+cf0qY1F7eYuqj3feMAaXcT2gNaLm6HvguE8Fi48IPCQAXHYuG9kK1EeIrSiJ3C5zmluLNBHCfNZHVJCHH3XVhjR5/wCXK+fAdXkWt6rP1SNy5F/VBa07rqR50XsDVJ3VAlXqnmqJCZ0ogmVCYZRCQKlMMqJI1iRNakpGBJRRR9T6c3wj0VuUYVXTXXYPQK5Jss2NAib8SswBVqvdcp5ipj0plmcJsLxdV6mY2VWGQ33KuiG9h5rgkSh7ZDbcrveHqUUOyd7w036WUGoMBYeYtgjoqlQ8p9HNxju3bgHgO/h6KZxtFQnUitHpUd+9ZdknBwOLXFoe3zGxQatEzXkCRg5X4HNx7FaOTibYD090Lq6Vr3XIbfGSFzvWjuxzoFf4UjyQZHlpyHC8QU9Po8UZBBe6Qm7nve6Q26DoFewzGOYvuq75Cbkm3nthS2VKVsstNyTyHhCl0dwdO3mA4i++bIXJObBrc3wOaK6LFwPjHMuNz1NiiHUZy4w/Xjwn0K851p9nn3Xo9f8AhPuvOdchJcfddkenm5txAz5cIRVv3V57HbZO/mqclK92zTldMTijpgeY7qm5HHaPIdxZUp9Oc3dM3jJAuQqlLuiE0Juqz6Zyzk0bxKzSkpf8Z3RJRZR9QaX+AegV9+yp6aPAPQK6/ZQxxA9WMrkLE+q3SgYTsCoXSmRVEahiZYq5OwjkpKaivkrSyK2Rtbhc4UTZSAKRsAHJIoBSxnoU6ipXB7X8he/ojToB0TmsAHz5YRYq2CK5hHiaL25BA56sAm4I9b7rU2BvYghwuCM3CG1NI25JA58rrnnF9OmEvhlqivybZ5bG902Hifk7G+Nso2+ijP5QPhcZTNGwFh7LNpmpXo6UDxEZtYKzLUdyDKQXCFrpC0WBIAvZThoA5YVOvBkaYmZfM1zPJjDguPoE1HaoHx2H6WqZVQxys4gyZjXt4hYgEXVWbQoX5cCT1uQs/wBpq9+nU8M9OTwUskUL4CfBLTnw2PQiwIK1Gj6tDVxMngeHxu9nNdza4ciF2VWzgdPTAtTocbNmj3yqLqBo2AWlr5ALoFUVTRuQn7pbM5Y4gyekHRBNRoxY4Rqo1FnLKD11YCDhRLL/AAlY0ZippM7KSDTQRspJagXyrdJVNWMpyOmMUVho46JI0yoB/wC0ln6mOonq9BGQwX6BWnbJ0TLBclXUSga+PieAicUQAVCI/eexRNqSGyJ8QKexgCkISCok6kkmOcALkgAAkk4ACAHLPdt9QNPRTOabPcwtadt0N137QKWn4mQn/JlGLRkCNrvN3/F0A7VVc9Rp8b32D5mmQtaCGtYb2A9gFSixWroP9gdRM+nUz3G72MdE8nJ4mkj6WRqq2v6/C83+zLUe6a6Bx8LiHsv+rmvR3vDgsJdaOmKqmUCL7/0JMZb+2Uz7BVpZzfhYOJx2A/nooo2sVQ+1mtHE91+Fu3ufJS0tKIwSTxPfYvftc9B0CZTwhpucvdfieenQeSsg3XRCFbfTmnl9aXDHfalOG0HCTmSoia0elyfovMez/aCooX95BIQHWEkbrujkHmP53Wr+1rUeKWCnBxEx0zx/s7A/YH5Xn91t8MH09Ng7XCqaCZGxyH8UZPDY+XVNmqupJ9V5lI61j5qxT6jIzAeSOjjxhYSxXxhZt5q0dUOqK2/NA26nxfiuPMZV2mIfkEH0yksVdC0hxuSrMBsuOjsFEJQFXlLoKVrQTjmKSqMkNuiSKX8I2fQrbplS7CnKp1TsINinEfvB5XRhpWZlquB4d039EWptRjcPxD3ICm6DoSVepqo4ml0j2RtG7nuEQ/dYH7QO25gLaSkeO/kHFLMLO7iPoP8AY/sF5ZV1cjzxSSPkdnxSvdM63utIxvZnKVaR7JrH2j0UAIjLqiQXsIwWsv5uP8XXlnaPtpV1pLZJOCInFPFdjLefN3us3LKSm8ex/t1oopCtsvwPsCeZ8LB/scBe3apRhscUZyGRRsI6kNsvFdBi7yrpIybB9TGXk5sxp4j+wK22pdtKyoqnMpo42RRyENY9neGUdXHlfyRTYRajtlF1BJSTki4ifcxyG1mu/SVtNJ1gSxB4OR4XjexWdZU1sjiHR08fiGO6MrXN5jxEomYJJIyGDgqInMPCAGNezmFjPC3tHRDPFOmHGyF4Bvg7ciR5KrS6xF3ncvAjkcbNJeJGyejuvl9VPUtjLibuJNzl1sLP6xpnGL8FyDdrcvN1cMcY/wCmeTLJ/wCGvcbX9m9c810kAdBa5O2FntE1GSwgqBwyAnu3k5eOh8/qpu1NY6KjqHg2Ihd4ul8CyuiE09njnaXUf8qsnmBu10jms/8AmMD9ghl1EE+6AOP2KY1de8DG56JrQgBwKlimLSC0kEcxhRJIAKDVnkWeAfMeAqenna44Oehwgl0rqXFMa1o1YOEln4K+RotxXHR3iwupeRUfUE+oxt3cPm6DV2txm4bcrMOe47kldC5XkbNS5LWl2w+VA55AJ6AnGFGFFXycMUjukbvmyi22HEeYxyGSomlNyS93mo6rZd0vaQ8+M/KWoOFrD8pDXeq9BaRzf9A1xuVI07KIJ7CmaBbszUBlfTOP4WvcHmxdZpaR/K9Y0rs7HfvOFwL7OBvt6rz/AOzbSRU1Ej3XAiY3hcACOIleyRQPYALtIFuXDhF0Hm3srS6ceHw2NtrixVWOLZ5aQ8gxkE8FxdF3PeATjCz/AGg0o1fD95wBofxsMYqGvBtyOxFsEJJg0EGRgWAAF7knZSiIDlfz81DTtDfCSTwNay5vc2Uxt1QUVqrT45LFwyMgjBBWR+1CrDKNsYdmaZgI2JaMlbQgjIdi2xyvK/tVrC+oijxaKIuIH6nH/pMkwi4QugJJANDAP7dNaU6U4t1+i4wJFDklwFK6AFdNuurg/vogB4KSakgD20Fduq7pgEmy3XnlWWLqnqb7wyDqxw91caLhCNaeWxyHyAVQVyQpOkef6Y6wlHR4KrvfcO83hSQvs+YDZzQ73uoR+H1cV3oyXSMhcJsCngJr2ElrBu5waPUplHq32X6e5lOJCf8AyEv4Bz8yvRiTsPdBuzNC2GnjY0bMbxE7k2Rhz7epUspcK9ZIWsIG5LW8zYEqGIeLrYXPPCklHO+bjzUBfwtcegcHepwPqgTezjAOEG1w67vdIkfXfonRCwa3k15bf6KEcvRvzxFMQnO9PXy/tl4h20qu8rpyNmvEbeeAF7PUyhjC84DGl5PkAD/BXgNXL3kkjzu973/JugCILq4k4oAifk+n1TiU1iRKRR0FdumgrpSAa4rqYDn0z7p9kAdBSXEkwPSZK/O6tUdRxFJJcbSokNwyC2UB7WVAbCQN3uA9kklWL9kOX6nnrTaQ+bHBPH4WefEUkl2EnYW3RHstR9/XwstdrHcbueAkkgD36Fga0DawCa+QBdSUotlSV29iDdp87H+hRTPsxwP53Nt6jP8ACSSZA+/nu6N19slVy7I5bHp+ddSQMDdp6ru6Sd97fcuY29vxFpH8rxApJIGhXTHn90kkhiXCkkgDgKTikkkAxnM9U9JJCAV0kkkwP//Z',
          provider: 'RAW',
        },
      },
    ],
    exhibition_halls: [
      {
        id: 'B3',
        name: 'B3',
        fair_id: 'bau23',
        booths: [
          {
            name: 'Test Booth',
            coordinates: '123',
            area: {
              width: 2,
              depth: 4,
              total: 6,
            },
          },
        ],
      },
    ],
    links: [
      {
        text: 'Plan.One',
        path: 'https://plan.one',
      },
      {
        text: 'Schüco',
        path: 'https://schueco.de',
      },
    ],
    logo: {
      description: 'Logo',
      resource:
        'https://files.api.plan.one/v1/images/a6c71802-dad7-4521-b0c9-7b5fd12ced64?quality=80&background=white&mode=PAD&width=100&height=100',
      provider: 'RAW',
    },
    mood_image: {
      description: 'Mood',
      resource:
        'https://www.schueco.com/resource/responsive-image/1902046/m01-stage/xxl/1/inspiration-meineschiebetuer-spring-img.jpg',
      provider: 'RAW',
    },
    videos: [
      {
        provider: 'YOUTUBE',
        resource: 'Bb7L3wBH3so',
      },
      {
        provider: 'YOUTUBE',
        resource: 'dYrMRd4DSkU',
      },
      {
        provider: 'YOUTUBE',
        resource: 'zXq_SL-wsrQ',
      },
    ],
    brands: [
      {
        name: 'Plan.One',
        logo: {
          description: 'Plan.One',
          resource:
            'https://lh3.googleusercontent.com/-0grpbwcfteg/AAAAAAAAAAI/AAAAAAAAAAA/58bb9XzwO6w/s44-p-k-no-ns-nd/photo.jpg',
          provider: 'RAW',
        },
      },
      {
        name: 'PlanToBuild',
        logo: {
          description: 'PlanToBuild',
          resource:
            'https://lh6.googleusercontent.com/-JekzGxeFuM4/AAAAAAAAAAI/AAAAAAAAAAA/HNchatNJNxQ/s44-p-k-no-ns-nd/photo.jpg',
          provider: 'RAW',
        },
      },
    ],
    gallery: [
      {
        description: 'Gebäude',
        resource: 'https://www.schueco.com/resource/responsive-image/1974872/m01-stage/xs/1/schueco-imagefilm-data.jpg',
        provider: 'RAW',
      },
      {
        description: 'Gebäude 2',
        resource:
          'https://www.schueco.com/resource/responsive-image/2105200/m01-stage/xs/2/karriere-stage-jobboerse-image.jpg',
        provider: 'RAW',
      },
      {
        description: 'Gebäude 3',
        resource:
          'https://www.schueco.com/resource/responsive-image/24500/m12e-teaser-product-tile/xs/1/schiebesysteme-produktuebersicht.jpg',
        provider: 'RAW',
      },
    ],
    downloads: [
      {
        name: 'Die neue Dimension des Wohnens mit Aluminium-Fenstersystemen',
        file_name: 'Aluminium-Fenstersystemen',
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8044/8703ffacc4ca3d22705b83fa5d46ba73/aluminium_fenster_systeme_p4035.pdf?domain=de',
      },
      {
        name: 'Schüco Living Classic',
        file_name: 'Schüco Living Classic',
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8046/d8c498415a5640cd526db2429652435d/schueco_livlng_classic_P4151.pdf?domain=de',
      },
      {
        name: 'Schüco Livlng Rondo',
        file_name: 'Schüco Livlng Rondo',
        size: <string>(<unknown>204800), // kann ignoriert werden
        path: 'https://www.schueco.com/resource/blob/8048/68b37e12213c9d37f8e09565e16a5caf/schueco_livlng_rondo_P4411.pdf?domain=de',
      },
    ],
    topics: [
      {
        id: '2',
        name: 'Fassadengestaltung',
        description: 'Fassadengestaltung',
      },
    ],
    product_groups: [
      {
        id: 'Fenstersystemen',
        external_id: '',
        name: 'Fenstersystem',
        root_path: [],
      },
    ],
    professions: [
      {
        id: 'architect.interior-architect',
        name: 'Architect',
        topics: [
          {
            id: 'sustainable',
            name: 'Sustainable',
            description: 'Sustainable',
          },
        ],
      },
    ],
    is_main: false,
  },
};
